var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65467 26.1498C8.58694 26.2876 5.16478 26.0736 3.89531 24.5679C3.44263 24.0291 3.02932 22.9048 2.96289 21.8322C4.50052 21.3942 8.36552 21.874 9.62515 22.4694L9.65467 26.1498Z",
    fill: "url(#paint0_radial_2007_1086)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65467 26.1497C8.58694 26.2875 5.16478 26.0734 3.89531 24.5678C3.44263 24.029 3.02932 22.9047 2.96289 21.832C4.93352 21.8862 7.87594 22.3831 9.62761 22.826L9.65467 26.1497Z",
    fill: "url(#paint1_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79932 21.8762C4.71452 24.0092 7.25345 24.6612 9.64232 24.6858L9.62756 22.8283C8.10961 22.4421 5.6986 22.0189 3.79932 21.8762Z",
    fill: "url(#paint2_radial_2007_1086)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80222 22.1371C6.40728 21.928 2.16095 20.4347 1.09568 18.0778C0.716807 17.2364 0.596254 15.6692 0.8964 14.2915C2.9925 14.2866 7.70381 16.2769 9.07907 17.4799C8.65345 19.0323 8.22537 20.5847 7.79975 22.1371H7.80222Z",
    fill: "url(#paint3_radial_2007_1086)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80222 22.1371C6.40728 21.928 2.16095 20.4347 1.09568 18.0778C0.716807 17.2364 0.596254 15.6692 0.8964 14.2915C3.36399 15.064 6.90178 16.7443 8.95605 17.9326C8.57226 19.3349 8.18601 20.7373 7.80222 22.1396V22.1371Z",
    fill: "url(#paint4_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93947 14.6458C2.33311 17.6669 5.30504 19.3989 8.31142 20.2821C8.52546 19.4973 8.74196 18.715 8.95599 17.9302C7.17726 16.9018 4.28405 15.5019 1.93701 14.6433L1.93947 14.6458Z",
    fill: "url(#paint5_radial_2007_1086)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0012 16.9854C6.37992 16.4269 1.64401 13.7035 0.896106 10.6528C0.630403 9.56541 0.834604 7.66613 1.49886 6.08667C4.00336 6.54673 9.18456 9.96888 10.5598 11.7083L7.99874 16.9854H8.0012Z",
    fill: "url(#paint6_radial_2007_1086)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0012 16.9854C6.37992 16.4269 1.64401 13.7035 0.896106 10.6528C0.630403 9.56541 0.834604 7.66613 1.49886 6.08667C4.27398 7.55542 8.12421 10.3453 10.3113 12.22L7.99874 16.9854H8.0012Z",
    fill: "url(#paint7_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66296 6.74097C2.46122 10.4337 5.62752 13.1621 9.02015 14.8843L10.3118 12.2199C8.4174 10.5961 5.27324 8.28352 2.66296 6.74097Z",
    fill: "url(#paint8_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87089 7.43241C5.14528 8.25659 6.79117 9.39074 6.75672 9.45225C6.72228 9.51129 4.95093 8.55673 3.65686 7.72026C2.36278 6.88379 2.22255 6.53444 2.2447 6.49999C2.26684 6.46309 2.59405 6.6107 3.86844 7.43487L3.87089 7.43241Z",
    fill: "url(#paint9_radial_2007_1086)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3452 26.1498C33.4129 26.2876 36.8351 26.0736 38.1046 24.5679C38.5572 24.0291 38.9706 22.9048 39.037 21.8322C37.4994 21.3942 33.6344 21.874 32.3747 22.4694L32.3452 26.1498Z",
    fill: "url(#paint10_radial_2007_1086)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3452 26.1497C33.4129 26.2875 36.8351 26.0734 38.1046 24.5678C38.5572 24.029 38.9706 22.9047 39.037 21.832C37.0664 21.8862 34.1239 22.3831 32.3723 22.826L32.3452 26.1497Z",
    fill: "url(#paint11_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.198 21.8762C37.2828 24.0092 34.7438 24.6612 32.355 24.6858L32.3697 22.8283C33.8877 22.4421 36.2987 22.0189 38.198 21.8762Z",
    fill: "url(#paint12_radial_2007_1086)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1977 22.1371C35.5927 21.928 39.839 20.4347 40.9043 18.0778C41.2832 17.2364 41.4037 15.6692 41.1036 14.2915C39.0075 14.2866 34.2962 16.2769 32.9209 17.4799C33.3465 19.0323 33.7746 20.5847 34.2002 22.1371H34.1977Z",
    fill: "url(#paint13_radial_2007_1086)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1978 22.1371C35.5927 21.928 39.839 20.4347 40.9043 18.0778C41.2832 17.2364 41.4037 15.6692 41.1036 14.2915C38.636 15.064 35.0982 16.7443 33.0439 17.9326C33.4277 19.3349 33.814 20.7373 34.1978 22.1396V22.1371Z",
    fill: "url(#paint14_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0605 14.6458C39.6668 17.6669 36.6949 19.3989 33.6885 20.2821C33.4745 19.4973 33.258 18.715 33.0439 17.9302C34.8227 16.9018 37.7159 15.5019 40.0629 14.6433L40.0605 14.6458Z",
    fill: "url(#paint15_radial_2007_1086)"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9986 16.9854C35.6198 16.4269 40.3557 13.7035 41.1037 10.6528C41.3694 9.56541 41.1652 7.66613 40.5009 6.08667C37.9964 6.54673 32.8152 9.96888 31.4399 11.7083L34.001 16.9854H33.9986Z",
    fill: "url(#paint16_radial_2007_1086)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9986 16.9854C35.6199 16.4269 40.3558 13.7035 41.1037 10.6528C41.3694 9.56541 41.1652 7.66613 40.501 6.08667C37.7258 7.55542 33.8756 10.3453 31.6885 12.22L34.0011 16.9854H33.9986Z",
    fill: "url(#paint17_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3373 6.74097C39.539 10.4337 36.3727 13.1621 32.9801 14.8843L31.6885 12.2199C33.5828 10.5961 36.727 8.28352 39.3373 6.74097Z",
    fill: "url(#paint18_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.129 7.43241C36.8546 8.25659 35.2088 9.39074 35.2432 9.45225C35.2777 9.51129 37.049 8.55673 38.3431 7.72026C39.6371 6.88379 39.7774 6.53444 39.7552 6.49999C39.7331 6.46309 39.4059 6.6107 38.1315 7.43487L38.129 7.43241Z",
    fill: "url(#paint19_radial_2007_1086)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4713 6.30308C11.5833 5.40018 13.3719 4.38165 15.4803 3.50828C17.5887 2.6349 19.5741 2.09366 20.9937 1.94604C22.4132 2.09366 24.3986 2.63736 26.507 3.50828C28.6154 4.38165 30.404 5.40018 31.5209 6.30308C32.4287 7.41509 33.4497 9.20367 34.3206 11.3121C35.194 13.4205 35.7352 15.4059 35.8853 16.8303C35.7377 18.2548 35.194 20.2402 34.3206 22.3486C33.4472 24.457 32.4263 26.2456 31.5209 27.3576C30.404 28.258 28.6154 29.279 26.507 30.1524C24.3986 31.0257 22.4132 31.567 20.9937 31.7146C19.5741 31.567 17.5887 31.0257 15.4803 30.1524C13.3719 29.279 11.5833 28.2605 10.4713 27.3576C9.56843 26.2456 8.54745 24.457 7.67407 22.3486C6.8007 20.2402 6.25945 18.2548 6.10938 16.8303C6.25699 15.4059 6.8007 13.4205 7.67407 11.3121C8.54745 9.20367 9.56843 7.41509 10.4713 6.30308Z",
    fill: "url(#paint20_radial_2007_1086)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5969 8.42625C13.4851 7.70541 14.912 6.89108 16.5948 6.19484C18.2775 5.4986 19.8619 5.0656 20.9961 4.94751C22.1278 5.0656 23.7146 5.4986 25.3974 6.19484C27.0802 6.89108 28.5071 7.70541 29.4002 8.42625C30.1235 9.31438 30.9378 10.7413 31.6365 12.4241C32.3327 14.1069 32.7657 15.6913 32.8863 16.8303C32.7682 17.9669 32.3352 19.5538 31.6365 21.2366C30.9403 22.9194 30.1259 24.3463 29.4002 25.2344C28.5071 25.9528 27.0802 26.7696 25.3974 27.4658C23.7146 28.1621 22.1302 28.5951 20.9961 28.7132C19.8644 28.5951 18.2775 28.1621 16.5948 27.4658C14.912 26.7696 13.4851 25.9553 12.5969 25.2344C11.8761 24.3463 11.0618 22.9194 10.3655 21.2366C9.66927 19.5538 9.23627 17.9694 9.11572 16.8303C9.23381 15.6937 9.66681 14.1069 10.3655 12.4241C11.0618 10.7413 11.8761 9.31438 12.5969 8.42625Z",
    fill: "url(#paint21_radial_2007_1086)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9961 28.0097C19.8521 27.8916 18.248 27.4537 16.548 26.75C14.848 26.0464 13.4038 25.2223 12.5059 24.494C11.7776 23.5961 10.9535 22.1544 10.2499 20.4519C9.7037 19.1357 9.3199 17.8761 9.11816 16.8428C9.23871 17.9794 9.67171 19.5588 10.3655 21.2343C11.0617 22.917 11.8761 24.344 12.5969 25.2321C13.485 25.9529 14.912 26.7673 16.5947 27.4635C18.2775 28.1597 19.8619 28.5927 20.9961 28.7108C22.1278 28.5927 23.7146 28.1597 25.3974 27.4635C27.0802 26.7673 28.5071 25.9529 29.4001 25.2321C30.1234 24.344 30.9402 22.917 31.6365 21.2343C32.3303 19.5588 32.7633 17.9794 32.8838 16.8428C32.6821 17.8761 32.2958 19.1357 31.7521 20.4519C31.0485 22.1519 30.2243 23.5961 29.4912 24.4916C28.5907 25.2198 27.1466 26.0415 25.4466 26.7451C23.7466 27.4487 22.1425 27.8867 20.9985 28.0072L20.9961 28.0097Z",
    fill: "url(#paint22_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5154 23.9524C25.267 23.9524 25.0209 23.9475 24.7749 23.9426C24.5289 23.9376 24.2829 23.9327 24.0418 23.9327H18.4079C18.0979 23.9327 17.7781 23.9376 17.4583 23.9401C17.136 23.945 16.8112 23.9475 16.4914 23.9475C16.3954 23.9475 16.3413 23.945 16.3118 23.9401C16.3069 23.9106 16.302 23.8614 16.297 23.7753L16.1962 20.4318C16.1962 20.3211 16.1937 20.2203 16.1912 20.1317C16.1847 19.9103 16.3052 19.7438 16.5529 19.6323C17.7756 19.0713 18.9762 18.3284 20.1251 17.4279C20.6393 17.0712 21.5373 16.2273 21.5668 15.3859C21.5865 14.8521 21.3946 14.5372 21.2298 14.3674C21.0108 14.1411 20.7057 14.0205 20.349 14.0205C20.0931 14.0205 19.8201 14.0845 19.5593 14.205C19.0205 14.456 18.5555 14.8964 18.1471 15.2851L17.9478 15.4745C17.7436 15.6418 17.6354 15.6615 17.6009 15.6615C17.5345 15.6615 17.4435 15.5385 17.35 15.3171C17.1507 14.8496 16.9539 14.3748 16.7546 13.9C16.5283 13.3563 16.302 12.8101 16.0707 12.2738C15.96 12.0204 15.9846 11.8457 16.1543 11.6636C17.1729 10.6254 19.2862 9.89722 21.2888 9.89722C22.3172 9.89722 23.2373 10.0867 23.9483 10.4434C25.6188 11.2799 26.1256 13.4104 25.7541 14.9923C25.235 16.8891 23.9212 18.3825 22.8338 19.4674L22.7133 19.588L22.7674 19.7504C22.7895 19.8192 22.824 19.8685 22.8461 19.898L22.9298 20.0677L23.1217 20.0554C23.4292 20.0284 23.7736 19.9841 24.123 19.9398C24.7036 19.866 25.3063 19.7873 25.7885 19.7873C26.2707 19.7873 26.3027 19.7971 26.3027 20.3015C26.315 20.8648 26.3101 21.4208 26.3076 21.9818C26.3076 22.2672 26.3027 22.5525 26.3027 22.8404C26.2929 22.9732 26.2953 23.1135 26.2978 23.2562C26.2978 23.3226 26.3027 23.3915 26.3027 23.4628C26.2904 23.8712 26.2018 23.9327 25.882 23.9426C25.7615 23.945 25.6385 23.9475 25.5154 23.9475V23.9524Z",
    fill: "#6993B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.4263,
    y: 9.29712,
    width: 11.4547,
    height: 15.2336,
    fill: "url(#pattern0_2007_1086)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67696 11.3119C8.55034 9.20351 9.57132 7.41494 10.4742 6.30292L10.6095 4.58569C9.71894 5.68295 8.71025 7.44938 7.84918 9.53072C6.9881 11.6121 6.45178 13.5728 6.30417 14.9801L6.11719 16.8006C6.26972 15.3786 6.81097 13.4056 7.67696 11.3119Z",
    fill: "url(#paint23_radial_2007_1086)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4717 6.30308C11.5837 5.40018 13.3723 4.38165 15.4807 3.50828C17.5891 2.6349 19.5745 2.09366 20.994 1.94604V0.2854C19.5941 0.430553 17.6334 0.966879 15.552 1.82795C13.4707 2.68903 11.7042 3.69771 10.607 4.58831L10.4717 6.30554V6.30308Z",
    fill: "url(#paint24_radial_2007_1086)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9937 1.94604C22.4132 2.09366 24.3986 2.63736 26.507 3.50828C28.6154 4.38165 30.404 5.40018 31.5209 6.30308L31.3856 4.58585C30.2834 3.69525 28.517 2.68903 26.4356 1.82795C24.3543 0.966879 22.3935 0.430553 20.9937 0.2854V1.94604Z",
    fill: "url(#paint25_radial_2007_1086)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5235 6.30292C32.4313 7.41494 33.4523 9.20351 34.3232 11.3119C35.1892 13.4056 35.7305 15.3762 35.883 16.8006L35.696 14.9801C35.5484 13.5728 35.0146 11.6121 34.151 9.53072C33.29 7.44938 32.2813 5.68541 31.3857 4.58569L31.5211 6.30292H31.5235Z",
    fill: "url(#paint26_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3233 11.3121C33.4499 9.24797 32.4289 7.4963 31.5236 6.40889C30.4067 5.52567 28.6181 4.52683 26.5097 3.67313C24.4013 2.81944 22.4159 2.28804 20.9963 2.14288C19.5768 2.28804 17.5914 2.81698 15.483 3.67313C13.3746 4.52683 11.586 5.52567 10.474 6.40889C9.57112 7.49876 8.55013 9.24797 7.67676 11.3121C8.55013 9.15941 9.57112 7.33393 10.474 6.19977C11.586 5.27965 13.3746 4.23652 15.483 3.34593C17.5914 2.45533 19.5768 1.90178 20.9963 1.75171C22.4159 1.90424 24.4013 2.45779 26.5097 3.34839C28.6181 4.23898 30.4067 5.27965 31.5236 6.20223C32.4314 7.33639 33.4524 9.16187 34.3233 11.3146V11.3121Z",
    fill: "url(#paint27_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6343 21.2366C30.938 22.9636 30.1237 24.4275 29.3979 25.3377C27.447 26.9246 23.5131 28.5778 20.9939 28.8435C18.482 28.5803 14.5358 26.9246 12.5947 25.3377C11.8739 24.4275 11.0595 22.9612 10.3633 21.2366C11.0595 22.8751 11.8739 24.2626 12.5947 25.1286C14.5604 26.6933 18.5041 28.2875 20.9939 28.5409C23.491 28.2851 27.4224 26.6909 29.3979 25.1286C30.1212 24.2651 30.938 22.8751 31.6343 21.239V21.2366Z",
    fill: "url(#paint28_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2992 14.2619C10.0187 14.9385 9.76781 15.6298 9.55377 16.3285C9.52425 16.4958 9.49964 16.6631 9.48242 16.8304C9.7186 18.0137 10.1245 19.2143 10.5871 20.3263C10.6412 20.4592 10.6978 20.5921 10.7568 20.7249C11.6646 20.8651 12.5946 20.9389 13.5418 20.9389C20.7133 20.9389 26.9056 16.7443 29.7989 10.6749C29.6906 10.5224 29.5799 10.3748 29.4643 10.2321C28.9427 9.81632 28.3547 9.44975 27.7741 9.12254C27.0188 8.69939 26.2291 8.32544 25.4295 7.99331C24.6299 7.66118 23.8058 7.36841 22.9718 7.13469C22.3321 6.9551 21.6605 6.80011 21.0011 6.72876C20.3393 6.80011 19.6677 6.9551 19.0305 7.13469C18.1965 7.36841 17.3748 7.66118 16.5728 7.99331C15.7732 8.32544 14.9835 8.69939 14.2282 9.12254C13.6476 9.44729 13.062 9.81386 12.5429 10.2321C12.1247 10.7512 11.7581 11.3367 11.4334 11.9173C11.0102 12.6726 10.6338 13.4624 10.3041 14.2619H10.2992Z",
    fill: "url(#paint29_radial_2007_1086)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0997 19.2217C23.0825 19.1873 23.0505 19.1553 23.0333 19.1036C24.3495 17.7874 25.5255 16.326 26.0274 14.4956C26.4309 12.7809 25.8601 10.5273 24.0765 9.63672C21.7048 8.44352 17.6184 9.21603 15.9528 10.916C15.7339 11.1522 15.6502 11.4376 15.8175 11.8239C16.2481 12.8276 16.6663 13.8609 17.0944 14.8671C17.3109 15.3764 17.5643 15.5904 18.1375 15.1205C18.5853 14.7023 19.0921 14.1709 19.6776 13.9003C20.4772 13.5288 21.3284 13.7896 21.2915 14.8179C21.2669 15.5092 20.487 16.2818 19.9556 16.6508C18.8633 17.5094 17.6848 18.2475 16.44 18.8207C15.8003 19.1061 15.9184 19.1233 15.9184 19.881C15.9528 21.0078 15.9848 22.1174 16.0193 23.2269C16.0365 23.6132 16.0857 23.6648 16.4892 23.6648C17.1288 23.6648 17.7832 23.6476 18.4057 23.6476H24.0395C24.6448 23.6476 25.2672 23.6821 25.8896 23.6648C26.394 23.6476 26.5613 23.4287 26.5785 22.9071C26.5785 22.6881 26.5613 22.5036 26.5785 22.2847C26.5785 21.4261 26.5957 20.5871 26.5785 19.7457C26.5785 19.0889 26.4432 18.956 25.7888 18.956C24.9941 18.956 23.9215 19.1553 23.0973 19.2242L23.0997 19.2217Z",
    fill: "url(#paint30_radial_2007_1086)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8523 8.96749C21.6627 7.79397 17.8888 8.55417 16.3512 10.2247C16.3118 10.2714 16.2773 10.3181 16.2478 10.3673L15.8296 11.0783C15.864 11.0193 15.9059 10.9652 15.9551 10.9135C17.6206 9.21597 21.707 8.441 24.0787 9.6342C24.8069 9.99832 25.3334 10.5888 25.6729 11.2776L25.2842 10.4904C24.9693 9.8507 24.4969 9.307 23.8548 8.96503L23.8523 8.96749Z",
    fill: "url(#paint31_radial_2007_1086)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0469 15.8635C19.0382 16.7073 17.9508 17.4355 16.7995 17.9965C16.5264 18.1269 16.4034 18.2007 16.3492 18.3138L15.9507 19.1429C16.0073 19.0248 16.1426 18.9486 16.4403 18.8157C17.6851 18.245 18.8611 17.5044 19.9559 16.6458C20.4873 16.2768 21.2697 15.5043 21.2918 14.813C21.2967 14.6457 21.2795 14.498 21.2426 14.3701C21.1959 14.562 21.1147 14.7367 20.9941 14.8671C20.6989 15.214 20.4037 15.5953 20.0469 15.8585V15.8635Z",
    fill: "url(#paint32_radial_2007_1086)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0888 18.368C25.9978 18.181 25.8083 18.1318 25.4368 18.1318C24.9571 18.1318 24.3666 18.2155 23.8057 18.2918C23.5572 18.5698 23.2989 18.8404 23.0332 19.1061C23.0504 19.1553 23.0849 19.1897 23.0996 19.2242C23.9238 19.1528 24.994 18.956 25.7911 18.956C26.197 18.956 26.4037 19.0077 26.5021 19.2045L26.0912 18.3729L26.0888 18.368Z",
    fill: "url(#paint33_radial_2007_1086)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0274 22.9537C26.0889 22.2451 26.0545 20.5279 26.02 19.8612C26.0126 19.721 25.9044 19.6078 25.7642 19.593C25.0605 19.5242 23.3827 19.7726 22.7652 19.8514C21.9607 19.9522 21.8131 19.748 22.4084 19.1428C23.7099 17.8168 24.9597 16.348 25.4763 14.4733C25.8306 12.948 25.3066 11.0069 23.8206 10.2615C21.7909 9.24293 18.076 9.70053 16.3661 11.4227C16.2751 11.5211 16.2874 11.5851 16.3415 11.7154C16.7352 12.6331 17.1264 13.7402 17.5594 14.6456C17.5864 14.7021 17.6356 14.739 17.6971 14.7513C17.7586 14.7636 17.8177 14.744 17.862 14.6997C18.2089 14.3626 18.7452 13.8214 19.439 13.4991C20.6494 12.9382 21.9115 13.5188 21.8598 14.9531C21.7958 16.7712 18.1301 18.791 16.6761 19.4528C16.6688 19.4553 16.6589 19.4602 16.6515 19.4651C16.5457 19.5119 16.4818 19.6127 16.4842 19.7308C16.5064 20.8035 16.5408 21.8761 16.5777 22.9463C16.5827 23.0964 16.7032 23.2169 16.8533 23.2219C18.1818 23.2612 22.9078 23.2957 25.7519 23.2145C25.897 23.2095 26.0151 23.0988 26.0274 22.9537Z",
    fill: "url(#paint34_radial_2007_1086)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.698 9.84826C21.7643 8.83219 18.2216 9.28979 16.5904 11.007C16.5732 11.0267 16.5585 11.0464 16.5486 11.0661L16.3198 11.4843C16.3297 11.4646 16.3444 11.4449 16.3641 11.4228C18.0764 9.70064 21.7889 9.24305 23.8186 10.2616C24.3819 10.5445 24.8076 10.9996 25.1003 11.5409C24.8322 10.8225 24.3672 10.2025 23.6955 9.85072L23.698 9.84826Z",
    fill: "url(#paint35_radial_2007_1086)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8278 14.5276C21.7662 16.3407 18.2727 18.3557 16.8852 19.0175C16.8778 19.0199 16.8704 19.0248 16.8606 19.0298C16.804 19.0568 16.7573 19.1011 16.7302 19.1552L16.5112 19.5931C16.5408 19.5366 16.5875 19.4923 16.649 19.4628C16.6588 19.4578 16.6662 19.4554 16.6736 19.4505C18.1276 18.7887 21.7933 16.7688 21.8573 14.9507C21.8622 14.7884 21.8524 14.6383 21.8253 14.498C21.8253 14.5079 21.8253 14.5177 21.8253 14.5276H21.8278Z",
    fill: "url(#paint36_radial_2007_1086)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.55 19.1577C24.8809 19.0888 23.2817 19.3373 22.6913 19.416C22.4576 19.4455 22.2829 19.448 22.1673 19.4209C21.8843 19.8096 22.0984 19.9351 22.7651 19.8515C23.3851 19.7752 25.0629 19.5243 25.7641 19.5931C25.8625 19.603 25.9437 19.6596 25.9855 19.7408L25.7616 19.3053C25.7198 19.2241 25.6435 19.1675 25.55 19.1577Z",
    fill: "url(#paint37_radial_2007_1086)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8622 10.0205C18.6838 10.2124 17.3602 10.6897 16.504 11.5508C16.4991 11.5557 16.4942 11.5631 16.4893 11.568C16.4942 11.5877 16.5089 11.6221 16.5163 11.6369C16.9321 12.6037 17.2765 13.61 17.7317 14.5596C18.2335 14.0725 18.7182 13.6223 19.3628 13.3246C20.7159 12.6972 22.1084 13.3959 22.0518 14.9582C22.0124 16.0923 20.7331 17.2314 19.503 18.0728C21.2768 17.9891 22.9301 17.4356 24.3349 16.5302C24.7482 15.8832 25.0828 15.1894 25.2944 14.4268C25.6289 12.9851 25.1418 11.135 23.737 10.4314C22.6127 9.86553 21.0849 9.82616 19.8647 10.023L19.8622 10.0205Z",
    fill: "url(#paint38_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0395 20.9905C21.8794 20.9905 19.8989 21.7679 18.3662 23.0571C18.5827 23.0571 18.7992 23.062 19.0157 23.062C20.0884 23.0718 21.1585 23.0743 22.2312 23.0694C23.4023 23.0644 24.5758 23.0546 25.7468 23.0226C25.796 23.0226 25.8354 22.9857 25.8379 22.9365C25.8723 22.533 25.8772 21.8368 25.8674 21.1799C25.2769 21.0544 24.6644 20.9905 24.0395 20.9905Z",
    fill: "url(#paint39_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4331 9.82371C22.4331 9.89506 21.0406 9.63674 19.5768 9.96395C18.0859 10.2961 16.8755 11.0956 16.8755 10.9874C16.8755 10.8865 18.0884 10.0205 19.5374 9.73023C21.1686 9.40056 22.4331 9.72038 22.4331 9.82617V9.82371Z",
    fill: "url(#paint40_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6228 9.1692C22.6228 9.25039 21.0286 8.97484 19.3581 9.39308C17.4293 9.87528 16.2705 10.7462 16.2705 10.6232C16.2705 10.5076 17.4957 9.49887 19.2646 9.11262C21.1294 8.70668 22.6228 9.04865 22.6252 9.1692H22.6228Z",
    fill: "url(#paint41_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9507 17.5141C19.9728 17.5781 19.2003 18.1858 18.4155 18.6532C17.6307 19.1207 16.8188 19.4602 16.8188 19.3864C16.8188 19.3175 17.6061 18.9312 18.4008 18.4441C19.2003 17.9521 19.9261 17.4477 19.9507 17.5166V17.5141Z",
    fill: "url(#paint42_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9358 16.6631C19.985 16.7246 19.0649 17.47 18.1472 18.0334C17.232 18.5968 16.2603 19.0077 16.2603 18.897C16.2603 18.8355 17.1878 18.3729 18.1251 17.7997C19.0747 17.2191 19.8792 16.5942 19.9333 16.6606L19.9358 16.6631Z",
    fill: "url(#paint43_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.224 19.6176C25.2327 19.4848 25.4984 19.5266 25.4984 19.5709C25.4984 19.6152 25.2278 19.6545 24.2216 19.7677C23.2178 19.8809 22.9595 19.8661 22.9595 19.8243C22.9595 19.7825 23.2153 19.7505 24.224 19.6201V19.6176Z",
    fill: "url(#paint44_radial_2007_1086)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4303 7.64634C18.177 6.92304 19.8229 6.47528 20.9964 6.35227C22.1724 6.47528 23.8183 6.9255 25.5626 7.64634C27.3093 8.36965 28.7904 9.2135 29.7154 9.9614C30.4658 10.8815 31.3121 12.3626 32.0354 14.1093C32.3405 14.8425 32.5963 15.5608 32.7981 16.2325C32.6135 15.1672 32.215 13.8313 31.6344 12.4265C30.9381 10.7437 30.1238 9.31683 29.398 8.42869C28.505 7.70785 27.0781 6.89352 25.3953 6.19728C23.7125 5.50104 22.1281 5.06804 20.994 4.94995C19.8623 5.06804 18.2754 5.50104 16.5926 6.19728C14.9099 6.89352 13.4829 7.70785 12.5948 8.42869C11.874 9.31683 11.0596 10.7437 10.3634 12.4265C9.78278 13.8313 9.38422 15.1672 9.19971 16.2325C9.4039 15.5608 9.65977 14.8449 9.96237 14.1093C10.6857 12.3626 11.532 10.8815 12.2774 9.9614C13.2 9.2135 14.6811 8.36965 16.4278 7.64634H16.4303Z",
    fill: "url(#paint45_radial_2007_1086)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2007_1086",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2007_1086",
    transform: "scale(0.00515464 0.00390625)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.92107 25.5151) scale(7.70046 7.70046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.59632 18.2942) scale(11.4326 11.4326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.75634 15.1451) scale(14.562 14.562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.82344 13.1992) scale(10.3427 10.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.58772 14.0799) scale(10.3501 10.3501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.76871 8.38207) scale(15.9594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.01058 5.58725) scale(14.2938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.30958 6.04485) scale(12.0231 12.0231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.80465 0.373941) scale(16.2497 16.2497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.39854 6.77062) scale(12.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0788 0.408645) rotate(-180) scale(7.70046 7.70046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4036 0.408515) rotate(-180) scale(0.12301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2434 0.408421) rotate(-180) scale(0.123011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8234 13.1992) rotate(180) scale(10.3427 10.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4123 14.0799) rotate(180) scale(10.3501 10.3501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2312 8.38207) rotate(-180) scale(15.9594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9892 5.58725) rotate(-180) scale(14.2938 14.2938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#98B1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#667CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#475C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C507A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6902 6.04485) rotate(-180) scale(12.0231 12.0231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F9DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#616E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#435172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#394666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1956 0.373941) rotate(180) scale(16.2497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5989 6.77062) rotate(-180) scale(12.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7298 3.13925) scale(33.7664 33.7664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37486E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8469 6.52696) scale(31.3037 31.3037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002945"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5564 25.2173) scale(25.9749 25.9749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90B0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5E7BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3F5B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344F8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2906 12.8791) scale(16.909 16.909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8594BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6574A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596996"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0713 1.05791) scale(23.1924 23.1924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8594BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6574A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596996"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3945 6.44577) scale(19.9991 19.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8491B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7986AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#59678D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5B82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0122 15.3688) scale(15.8093 15.8093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8491B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7986AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#59678D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5B82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8128 0.905396) scale(30.5829 30.5829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2193 28.2925) scale(25.4976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3008 1.63366) scale(24.5628 24.5627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#003B75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#002142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#001122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1436 10.4658) scale(16.0332 16.0332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4CDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#AEC8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8EABE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A0DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0366 8.82233) scale(10.4018 10.4018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90B0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5E7BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3F5B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344F8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2238 18.4245) scale(7.0485 7.04851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90B0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5E7BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3F5B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344F8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6658 19.1405) scale(4.96963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90B0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5E7BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3F5B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344F8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5521 9.78172) scale(16.7983 16.7983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0039BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7592 9.41772) scale(8.72391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3685FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F469C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3845 15.0295) scale(6.91812 6.91812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3685FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F469C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3965 20.346) scale(7.07802 7.07803)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2E66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2951 5.93657) scale(16.5302 16.5302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#009BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#005E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#003142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#001622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1848 31.7908) scale(16.1414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#009BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#005E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#003142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#001622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3357 9.68348) scale(9.51117 9.51118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#55A8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#316575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#163542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#061722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7824 8.76573) scale(8.23432 8.23433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0982 19.2879) scale(7.76443 7.76443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#55A8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#316575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#163542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#061722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4362 17.6939) scale(6.26862 6.26862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B2C5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#83949C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5B696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3A4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#202B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E1711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#030B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0064 18.8574) scale(8.44099 8.44098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#55A8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#316575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#163542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#061722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C17"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2007_1086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7283 16.4883) scale(13.6124 13.6123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8EEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCDAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A6BFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#769CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6993B5"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2007_1086",
    width: 194,
    height: 256,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAAEACAYAAADhtqk6AAAACXBIWXMAAC4jAAAuIwF4pT92AAAJBUlEQVR4nO3dQXrbuBKF0at8Xp43koFXk4E3kv2lB93qyDIlgSSAulX4z/B1ngyi6rJISrIvwhc/f/3+E72GWT4/3i/Ra3Cx/Eas1PivrByMpQ6cpt9npWCUPlAav5/qoSh1cDT+eFUDkf6gaP44lUKR8kBofi8VApHqAAiAv6yhsF80zZ9TtkDYLpYA5JcpDFYLpflryhAIiwUSgPrcwxC6OAKwHtdATF8UzQ/HMExbEAHAPadADF8IAcAzLmEYtggCgFYOYRiyAELwV+8iV93b6DBQpBOii7clcw0i97PbD85cgFccG36vLPWJ2uvTPzTLBreq0PQtnOsWUYPDP9B5I/dYpfGfcazl7Loc+mGOG9eKxn/OqbYza7X7BzltVCua/xiHWs+q3a4f4rAxLWj8vqLrPqOezT8gejNaEICxIntgdG1fvrh7AGj++SJ6IjQIriGg+T3M7o+RdX/4wo4hIAB+qoRh80XdQkAAvM3sl2lBcAoBAchlVu+M6IsvL+gSAgKQV9Yw/P9iDiEgADXM6KWSQSAA9WQLw0WKCwEBqC1TGH70eJEjCEF9mWp8qfIcGL5G9ljKiUAI0FuvkE0JwufH+4UQrCtD7YcHIcMmYLyRfdBjKgwNAiHALed+eBvxos4HDGzpPhEIAZ4Z1R9nL4+6BoEQoIVjn3QNgsPnlbCuM/0X9s4y1uY2FQgCoAFB4PIIrUZMhaP9x0QANCgITAW0cpkKTARA0g/XNziAmZgICOdwefRj1EKATIZOBC6P0Cr6ZMylEaCbIHDTjJUxEVDWnpPwlyBEX6dhbZH9N2UicHkEd9+CwFTAiqbdIzAV4IybZViJuiLZDAKPUlFFa88xEQA9CQI3zVjJ9InA5REcPf1Nd58f79N/bXwmj/aGaZrPy4KNCkKWZul1/FmO10XPvmvZ+yG/+zS7EeHfek3C4aOpEKtMBf6WnI/etXi1x8tPBId7oOsaCEScpqdGVQvkEIJbbutZSegbalGF//nr9x/XpnNeW2VLvbOcqcmyrLOK5iBk//xRxsbKuOasyk+ETFNgS+a1Z7IrCNlumqs0UZXjcGYxEXoXOvsU2FLteNzsDoL7VKBhcITFRJDON3DFKXCv+vFFsgnCGSs1yErHOtOhIDg9SqUx0EPqibBqCFY97pEOByH6pplmqGv2J08lw4nQsgmEAL3ZBeGZFZ4MtWIf+jr1fYRR32n++ev3n/tx5lb4V+PWbb14LsUXc1yaas990fXfuqwdz52+NBp90+zQSJ8f75ejx3nm//uKw95U0aVAVQvSu4FH7FP007veIp4YSZ1ulqsVY+RZHJ5SPTWaYWQACJevFDfLM9Cka+s2ETI30sy1Z96n0SLvNZe/NKIxIXUOQqamqnJDXPWJ3WxLToQKAagm+tFy9yC4N5n7+hBjqYlACNaxt9bLBIEQ+HK4zxkSBLemc1sP/JSfCITAW/RN8tWwIDg0oMMa7jlcBuC7kh+xcAzAKCsda4uj+zH00iiiSDRGHk7TsdQ9gnsInAqPr4YHYVZzuocAX7ncJF+VmAgZQsA08DYlCKt/2WWVP8/byvGkMG0ijCha1kZAf2d7YeqlUa/GzfQRasezXyTX/Zh+j3C2gbMEQBpb9Ez7MFqPvQh5Q23vL7+i6DW4TgMp+J3l2wa/36Tsze9cdHyXutlcjQ5BxpOE+5OzEu8jOCEEORGEjrgc2pZhXzi7dDKj2BmnQZYnZ0yEDjKc8fBcujOMm1khYBp81Xs/mAgnEII6CMJBXA49l2kaSFwaHTIzBBmnQbYQSEW/szzK7CmQMQRZcWnUiEuhNhmngUQQmkSEgGkwF5v9AiFol3UaSAThoahLIULw3Yw94dJoAyHYp8L9E0G4Qwi8zNoXHp/+J/KsljkEFaaBxD2CJEJwVKXvXix/aVTljIZz0p6NznIIANPgsdl7k7YQZxCCc6qFQFrsZpkAnOewhyMsc4/gUMDsIZghao+WCAIh6MNhH0dJX5xnXApHCNpE7lP6Aj3iEIIKAZDqh0AqeLPsEAApvrC9uOznaKXuEVyKViUEszjsV/gCenAJgORR1F5WuCS6sljEGS4hcCloLyuFQEocBJcASF4F7WG1EEgJb5YJwFhO+ztTqkI6FYkQHOe4d3YL2uIUAMmzkGetHALJPAgEYI7VQyAZv49ACDCTXXEJwFxMg3/ZLM4tAJJ/8c4iBH+FL5AAxCAEX4XeIxCCGI77Hi2k6K6FIAR9ZdrPqQslALEIwWNTFusaAClfwY4iBM8NXTAB8EAIXhvyoTvnAEh5i3WEey1cdG0I901fKQASf/Ntjy4Ldw+AlLtIRxCCfU4tPkMApPxF2osQ7HfoAAiAL0JwzK6DIADeCMFxTU+NCADujdjr3n22Z40v/yEhyMH5vYLoHmpZ78N/EL34VqsH4Cry06QVemXzP2Q4MALwV4Z6OdnqHduvaj7y+fF+IQQ4Y+vE8e1m2fXsQvNjJPuJwATACPcn/Ldn/zESzY+ZLCcCIcAMtyf+t63/MQoBQBSLicB9AKJcB0BoEAhAH+zheSG/Fp7Cwc3UIBAAuJpyacQl0Hjs7znDg0CBkMGwIDAF5mO/j7N4fApEIwjFMBWOIQgFEYb90v15WdS0J7wjPg5EEIr6/Hi/OHx+TMoxoQhCYbPCkKHRXyEIxd026ZFQVGjyFgRhIas09RE8NQJEEABJBAGQRBAASQQBkEQQAEkEAZB0EwSeMWNlTARABAGQRBAASQQBkEQQAEkEAZA0MAgu344CWjARABEEQBJBACQRBEASQQAkEQRAEkEAJBEEQBJBACQRBEASQQAkEQRAEkEAJBEEQBJBACQRBEASQQAkEQRAEkEAJBEEQBJBACQRBEASQQAkEQRAEkEAJN0FgT8WglUxEQARBEASQQAkEQRAkvQ28sX51fDIgokAiCAAkggCIIkgAJIIAiCJIACSCAIWd/18HUEARBAASQQBkEQQsLDb7998CwJfzsGKHjY9H5hDZfcn/IeXRkwGrORlszMZUM3WSb7prE8YUMGzq5zmyx/CgMxeXervug8gDMio5X539w0xYYA7HvQAB/0DuuNwYIdEPeIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop2);
export default __webpack_public_path__ + "static/media/top2.a0fe1fdc7c775c1b8d6d04adc89d9baa.svg";
export { ForwardRef as ReactComponent };